

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class APPCC_Task_ManagedObject

class APPCC_Task_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: info
    set info(value:string) {
        this.setValueForKey(value, 'info');
    }
    get info():string {
        return this.valueForKey('info');
    }
    set infoPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'info');
    }
    get infoPrimitiveValue():string {
        return this.primitiveValueForKey('info');
    }

    // Property: inputType
    set inputType(value:number) {
        this.setValueForKey(value, 'inputType');
    }
    get inputType():number {
        return this.valueForKey('inputType');
    }
    set inputTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'inputType');
    }
    get inputTypePrimitiveValue():number {
        return this.primitiveValueForKey('inputType');
    }

    // Property: maxExpected
    set maxExpected(value:number) {
        this.setValueForKey(value, 'maxExpected');
    }
    get maxExpected():number {
        return this.valueForKey('maxExpected');
    }
    set maxExpectedPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'maxExpected');
    }
    get maxExpectedPrimitiveValue():number {
        return this.primitiveValueForKey('maxExpected');
    }

    // Property: minExpected
    set minExpected(value:number) {
        this.setValueForKey(value, 'minExpected');
    }
    get minExpected():number {
        return this.valueForKey('minExpected');
    }
    set minExpectedPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'minExpected');
    }
    get minExpectedPrimitiveValue():number {
        return this.primitiveValueForKey('minExpected');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: requiresPhoto
    set requiresPhoto(value:boolean) {
        this.setValueForKey(value, 'requiresPhoto');
    }
    get requiresPhoto():boolean {
        return this.valueForKey('requiresPhoto');
    }
    set requiresPhotoPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'requiresPhoto');
    }
    get requiresPhotoPrimitiveValue():boolean {
        return this.primitiveValueForKey('requiresPhoto');
    }
    // Relationship: list
    set list(value:APPCC_List) {
        this.setValueForKey(value, 'list');
    }
    get list():APPCC_List {
        return this.valueForKey('list') as APPCC_List;
    }

    // Relationship: results
    protected _results:MIOManagedObjectSet = null;
    get results():MIOManagedObjectSet {
        return this.valueForKey('results');
    }
    addResultsObject(value:APPCC_TaskResult) {
        this._addObjectForKey(value, 'results');
    }
    removeResultsObject(value:APPCC_TaskResult) {
        this._removeObjectForKey(value, 'results');
    }
}
